import IconCancel from '@bimser/icons/16/cancel';
import IconDelete from '@bimser/icons/16/delete';
import IconEdit from '@bimser/icons/16/edit';
import IconOk from '@bimser/icons/16/ok';
import { BCDataGrid } from '..';

const editorColumnButtons = (fixed?: boolean) => (
	<BCDataGrid.Components.Column
		type="buttons"
		fixed={fixed}
		fixedPosition="left"
	>
		<BCDataGrid.Components.ColumnButton
			icon={IconEdit.info.getElement()}
			cssClass="dx-link"
			name="edit"
			key="edit"
		/>
		<BCDataGrid.Components.ColumnButton
			icon={IconDelete.info.getElement()}
			cssClass="dx-link"
			name="delete"
			key="delete"
		/>
		<BCDataGrid.Components.ColumnButton
			icon={IconOk.info.getElement()}
			cssClass="dx-link"
			name="save"
			key="save"
		/>
		<BCDataGrid.Components.ColumnButton
			icon={IconCancel.info.getElement()}
			cssClass="dx-link"
			name="cancel"
			key="cancel"
		/>
		<BCDataGrid.Components.ColumnButton
			icon={IconCancel.info.getElement()}
			cssClass="dx-link"
			name="undelete"
			key="undelete"
		/>
	</BCDataGrid.Components.Column>
);

export { editorColumnButtons };
